<template>
  <vs-dropdown class="cursor-pointer" vs-custom-content vs-trigger-click>
    <span class="cursor-pointer flex items-center i18n-locale">
      <img :alt="$i18n.locale" :src="i18n_locale_img" class="h-4 w-5"/>
      <span class="hidden sm:block ml-2">{{ $t('layout.nav-bar.' + getCurrentLocaleData.lang) }}</span>
    </span>
    <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
      <vs-dropdown-item @click="updateLocale('en')"><img alt="en" class="h-4 w-5 mr-1"
                                                         src="@/assets/images/flags/en.png"/> &nbsp;{{$t('layout.nav-bar.english')}}
      </vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('th')"><img alt="th" class="h-4 w-5 mr-1"
                                                         src="@/assets/images/flags/th.png"/> &nbsp;{{$t('layout.nav-bar.thai')}}
      </vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
  export default {
    computed: {
      i18n_locale_img() {
        return require(`@/assets/images/flags/${this.$i18n.locale}.png`)
      },
      getCurrentLocaleData() {
        const locale = this.$i18n.locale;
        if (locale === "en") return {flag: "us", lang: 'english'};
        else return {flag: "th", lang: 'thai'};
      },
    },
    methods: {
      updateLocale(locale) {
        localStorage.setItem('currentLanguage', locale);
        this.$i18n.locale = locale;
        this.$store.dispatch('setLanguage', locale);
      },
    }
  }
</script>
